import { createSelector } from '@reduxjs/toolkit'
import { AppState } from 'store/appState'

export const getAIAgentSessionId = createSelector(
  (state: AppState) => state.ai.popup,
  popup => popup.sessionId,
)
